import { useMemo } from 'react';
import {
  Award,
  Briefcase,
  Building2,
  FileText,
  Globe,
  Link2,
  Sparkles,
  Star,
  User,
  Users,
  Wrench,
} from 'lucide-react';
import type { Section } from '@/components/SectionNavigation';

export function useProfileSettingsSections(isSupplierProfile: boolean): Section[] {
  return useMemo(() => {
    const sections: Section[] = [
      {
        id: 'connected-accounts',
        labelKey: 'navigation.sections.profile.connectedAccounts',
        icon: Link2,
      },
    ];

    if (isSupplierProfile) {
      sections.push({
        id: 'profile-completeness',
        labelKey: 'profileCompleteness.title',
        icon: Sparkles,
      });
    }

    sections.push(
      {
        id: 'personal-info',
        labelKey: 'profile.personalInfo.title',
        icon: User,
      },
    );

    if (isSupplierProfile) {
      sections.push({
        id: 'profile-credentials',
        labelKey: 'profile.credentials.title',
        icon: FileText,
      });
    }

    sections.push(
      {
        id: 'expertises',
        labelKey: 'profile.expertises.title',
        icon: Star,
      },
      {
        id: 'language-skills',
        labelKey: 'profile.languageSkills.title',
        icon: Globe,
      },
      {
        id: 'skills',
        labelKey: 'profile.skills.title',
        icon: Wrench,
      },
    );

    if (isSupplierProfile) {
      sections.push(
        {
          id: 'collaboration-preferences',
          labelKey: 'profile.collaborationPreferences.title',
          icon: Users,
        },
        {
          id: 'industries',
          labelKey: 'profile.industries.title',
          icon: Building2,
        },
        {
          id: 'seniority',
          labelKey: 'profile.seniority.title',
          icon: Briefcase,
        },
        {
          id: 'certifications',
          labelKey: 'profile.certificationsStructured.title',
          icon: Award,
        },
        {
          id: 'case-studies',
          labelKey: 'profile.caseStudies.title',
          icon: FileText,
        },
      );
    }

    return sections;
  }, [isSupplierProfile]);
}
